import React, { Suspense, useMemo } from "react";
import { useLocation } from "react-router";
import { noNavigationRoutes, publicRoutesName } from "../Utils/utils";

const TopNavigation = React.lazy(() => import("./TopNavigation"));

const NavigationWrapper = ({ show = ["private"], runQueries = true }) => {
  const { pathname } = useLocation();
  const hiddenRoutes = useMemo(() => {
    let routes = [];
    if (show.includes("private")) {
      routes = routes.concat(noNavigationRoutes);
    }
    if (show.includes("public")) {
      routes = routes.concat(publicRoutesName);
    }
    return routes;
  }, [show]);

  const shouldShowNavigation =
    hiddenRoutes.filter((item) => pathname.includes(item)).length === 0;

  if (!shouldShowNavigation) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <TopNavigation runQueries={runQueries} />
    </Suspense>
  );
};

export default NavigationWrapper;
